export default "/images/ru-room-tour-desktop.png?076b1d7d8fc51f7d817ddcce5684661b";